import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { hierarchyContext } from "./CompanyHierarchyContext.js";
import { map as map_1, equalsWith, tryHead, tryFind, collect, sortBy } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Array_distinctBy } from "./fable_modules/fable-library-js.4.24.0/Seq2.js";
import { defaultOf as defaultOf_1, equals, createObj, uncurry2, comparePrimitives, numberHash } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { CustomerContact_$reflection } from "./Shared/ApiDataTypes.js";
import { anonRecord_type, string_type, obj_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { orElse, toArray, some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { singleton, append, delay, toList, iterate } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { MenuItem, TextField, Divider, Typography } from "@mui/material";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { loadingIndicator, loadingIndicatorSmall, SnackError } from "./ViewHelpers.js";
import { Components_Button_Z1043B8E } from "./Components/Button.js";
import OpenInNew from "@mui/icons-material/OpenInNew";

export function ContactInfo(contactInfoInputProps) {
    let elems_8, elems_7, elems_13, elems_12;
    const customerId = contactInfoInputProps.customerId;
    const key = contactInfoInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const patternInput = reactApi.useState(undefined);
    const contactInfos = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const pdfContent = patternInput_2[0];
    const allCustomers = sortBy((customer_1) => customer_1.Name.toLocaleLowerCase(), Array_distinctBy((customer) => customer.Id, collect((group) => group.Customers, hierarchy.Groups), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }), {
        Compare: comparePrimitives,
    });
    let initialCustomer;
    if (customerId != null) {
        const id = customerId | 0;
        initialCustomer = tryFind((c) => (c.Id === id), allCustomers);
    }
    else {
        initialCustomer = tryHead(allCustomers);
    }
    const patternInput_3 = reactApi.useState(initialCustomer);
    const selectedInfo = patternInput_3[0];
    useEffectOnce(() => {
        let properties_6;
        let pr_5;
        let pr_4;
        const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(CustomerContact_$reflection()), undefined, undefined);
        const data_5 = undefined;
        const caseStrategy_10 = undefined;
        const extra_10 = extraCoders;
        try {
            const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_10), unwrap(extra_10))(data_1_2))]), properties_6), data_5), properties_6)));
            const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/customer/user-contacts", properties_3_1).then((_arg_3) => {
                let response_3, decoder_1_2;
                return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(CustomerContact_$reflection()), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_4) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
            }))));
            pr_4 = (pr_3.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn_1) {
            pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
        }
        pr_5 = (pr_4.then((result_3) => Result_MapError(testRedirect, result_3)));
        pr_5.then((res_1) => {
            if (res_1.tag === 0) {
                const x_4 = res_1.fields[0];
                console.debug("Found posters: %o", x_4);
                patternInput[1](x_4);
            }
            else {
                console.error(some("Error fetching customer contact posters: %s"), res_1.fields[0]);
                setErrMsg("Kunne ikke hente plakater. Vennligst prøv igjen senere.");
            }
        });
    });
    const dependencies = [selectedInfo];
    reactApi.useEffect(() => {
        iterate((selected) => {
            let properties_2;
            let pr_6;
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(anonRecord_type(["Content", string_type]), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/customer/${selected.Id}/contact-poster`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(anonRecord_type(["Content", string_type]), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_6 = (pr_2.then((res) => {
                if (res.tag === 0) {
                    patternInput_2[1](res.fields[0]);
                }
                else {
                    console.error(some("Error fetching contact poster"), res.fields[0]);
                }
            }));
            pr_6.then();
        }, toArray(selectedInfo));
    }, dependencies);
    const contactData = (accountInfo) => {
        let elems_4;
        const title = (text) => createElement("div", {
            style: {
                flexGrow: 1,
                maxWidth: 40 + "ch",
            },
            children: MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", text]]),
        });
        const value_59 = (child) => createElement("div", {
            style: {},
            children: child,
        });
        const row = (children_1) => createElement("div", {
            style: {
                display: "flex",
            },
            children: reactApi.Children.toArray(Array.from(children_1)),
        });
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 20 + "px",
            width: 100 + "%",
        }], (elems_4 = [row([title(ctx.Locale.t("Customer.Name")), value_59(`${accountInfo.FirstName} ${accountInfo.LastName}`)]), MuiHelpers_createElement(Divider, []), row([title(ctx.Locale.t("Login.Email")), value_59(accountInfo.Email)]), MuiHelpers_createElement(Divider, []), row([title(ctx.Locale.t("UserAdmin.Phone")), value_59(accountInfo.Phone)])], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    };
    const tableInfo = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 600 + "px",
        maxWidth: 700 + "px",
    }], (elems_7 = toList(delay(() => {
        let matchValue_3, accountInfo_1;
        if (selectedInfo != null) {
            const info = selectedInfo;
            return append((matchValue_3 = info.Responsible, (matchValue_3 != null) ? ((accountInfo_1 = matchValue_3, append(singleton(MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerAdmin.CustomerResponsible")]])), delay(() => {
                let elems_5;
                return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], (elems_5 = [contactData(accountInfo_1)], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
            })))) : singleton(defaultOf())), delay(() => {
                const matchValue_4 = info.ServiceLead;
                if (matchValue_4 != null) {
                    const accountInfo_2 = matchValue_4;
                    return append(singleton(MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerAdmin.ServiceLead")]])), delay(() => {
                        let elems_6;
                        return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], (elems_6 = [contactData(accountInfo_2)], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                    }));
                }
                else {
                    return singleton(defaultOf());
                }
            }));
        }
        else {
            return singleton(defaultOf());
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
    const xs_17 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_1[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    }), MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", "Kontakt"]]), createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container", "main-tab-container-outer"])], ["style", {
        height: ("calc(" + "100vh - 120px - 72px - 30px - 30px") + ")",
    }], (elems_13 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner"])], ["style", {
        rowGap: 30 + "px",
    }], (elems_12 = toList(delay(() => {
        let elems_11;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            columnGap: 15 + "px",
        }], (elems_11 = toList(delay(() => {
            let matchValue_5, elems_10, elems_9;
            return append((matchValue_5 = allCustomers, (!equalsWith(equals, matchValue_5, defaultOf_1()) && (matchValue_5.length === 0)) ? singleton(defaultOf()) : singleton(createElement("div", createObj(ofArray([["style", {
                flexBasis: 320,
            }], (elems_10 = [MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("Customer.Customer")], ["fullWidth", true], ["size", "small"], ["select", true], ["value", orElse(map((si) => si.Id, selectedInfo), -1)], ["onChange", (ev) => {
                const cId = ev.target.value | 0;
                patternInput_3[1](tryFind((y_3) => (y_3.Id === cId), allCustomers));
            }], (elems_9 = [map_1((contact) => MuiHelpers_createElement(MenuItem, [["value", contact.Id], ["children", contact.Name]]), allCustomers)], ["children", reactApi.Children.toArray(Array.from(elems_9))])])], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))))), delay(() => append(singleton(createElement(Components_Button_Z1043B8E, {
                text: ctx.Locale.t("WebContact"),
                onClick: (value_143) => {
                },
                startIcon: (props_24) => {
                    const props_26 = createObj(props_24);
                    return react.createElement(OpenInNew, props_26);
                },
                href: "https://www.ptg.no/kontakt",
            })), delay(() => append(singleton(createElement(Components_Button_Z1043B8E, {
                text: ctx.Locale.t("ContactNews"),
                onClick: (value_144) => {
                },
                startIcon: (props_27) => {
                    const props_29 = createObj(props_27);
                    return react.createElement(OpenInNew, props_29);
                },
                href: "https://www.ptg.no/nyheter",
            })), delay(() => append(singleton(createElement(Components_Button_Z1043B8E, {
                text: ctx.Locale.t("ContactProducts"),
                onClick: (value_145) => {
                },
                startIcon: (props_30) => {
                    const props_32 = createObj(props_30);
                    return react.createElement(OpenInNew, props_32);
                },
                href: "https://www.ptg.no/produkter",
            })), delay(() => singleton(createElement(Components_Button_Z1043B8E, {
                text: ctx.Locale.t("Website"),
                onClick: (value_146) => {
                },
                startIcon: (props_33) => {
                    const props_35 = createObj(props_33);
                    return react.createElement(OpenInNew, props_35);
                },
                href: "https://www.ptg.no",
            }))))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
            let x_5, elems_2;
            if (contactInfos != null) {
                if (selectedInfo != null) {
                    const contacts = contactInfos;
                    const si_1 = selectedInfo;
                    const matchValue_7 = tryFind((c_2) => (c_2.CustomerId === si_1.Id), contacts);
                    return (matchValue_7 != null) ? singleton((x_5 = matchValue_7, createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        width: 100 + "%",
                        minHeight: 200,
                        flexGrow: 1,
                    }], (elems_2 = toList(delay(() => {
                        if (pdfContent != null) {
                            const content = pdfContent;
                            const matchValue_2 = x_5.FileExt.trim().toLocaleLowerCase();
                            switch (matchValue_2) {
                                case ".pdf":
                                case "pdf":
                                    return singleton(createElement("embed", {
                                        src: `data:application/pdf;base64,${content.Content}`,
                                        type: "application/pdf",
                                        style: {
                                            width: 100 + "%",
                                            height: 100 + "%",
                                        },
                                    }));
                                default:
                                    return singleton(createElement("img", {
                                        style: {
                                            width: 100 + "%",
                                        },
                                        src: `data:image/${x_5.FileExt};base64,${content.Content}`,
                                    }));
                            }
                        }
                        else {
                            return singleton(loadingIndicatorSmall());
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))) : singleton(tableInfo);
                }
                else {
                    return singleton(defaultOf());
                }
            }
            else {
                return singleton(loadingIndicator());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))];
    return react.createElement(react.Fragment, {}, ...xs_17);
}

